'use client';

import { Stack } from '@unifyapps/ui/components/Stack';
import { clsx } from 'clsx';
import map from 'lodash/map';
import { forwardRef } from 'react';
import { DATA_NAV_ROOT_ATTRIBUTE } from '../../constants';
import type { BottomNavProps } from '../../types';
import NavItemComponent from '../SideNavigation/NavigationItemComponent';
import { useBottomNavigation } from './hooks/useBottomNavigation';
import { getIsNavigationEmpty } from '../../utils/emptyNavigation';

export const BottomNavigation = forwardRef<HTMLDivElement, BottomNavProps>((props, ref) => {
  const {
    slotProps,
    adaptedNavItems,
    hasActiveNavItem,
    activePathnames,
    activeMenuItemId,
    setActiveMenuItemId,
    hoverProps,
    heightClassName,
    theme,
    rootClassName,
    className,
    heightStyles,
    style,
  } = useBottomNavigation(props);

  const isNavigationEmpty = getIsNavigationEmpty({
    primary: adaptedNavItems,
  });

  // If BottomNav doesnt have item corresponding to activePage, hide it
  if (isNavigationEmpty || !hasActiveNavItem) return null;

  return (
    <Stack
      aria-label="bottom-nav"
      className={clsx('relative h-full w-full', rootClassName, heightClassName)}
      data-color-scheme={theme}
      ref={ref}
      style={heightStyles}
    >
      <Stack
        className={clsx('ua-side-nav z-navbar h-full overflow-hidden', className)}
        {...{ [DATA_NAV_ROOT_ATTRIBUTE]: 'bottom' }}
        {...hoverProps}
        style={style}
      >
        <Stack
          className="grid h-full w-full auto-cols-fr grid-flow-col justify-between overflow-visible overflow-x-auto overflow-y-hidden"
          direction="row"
        >
          {map(adaptedNavItems, (item) => {
            return (
              <NavItemComponent
                activeMenuItemId={activeMenuItemId}
                activePathnames={activePathnames}
                item={item}
                key={item.id}
                setActiveMenuItemId={setActiveMenuItemId}
                slotProps={slotProps}
              />
            );
          })}
        </Stack>
      </Stack>
    </Stack>
  );
});

BottomNavigation.displayName = 'BottomNavigation';
